<footer class="footer-wrap">
  <img src="assets/images/footer-logo.png" alt="logo" />
</footer>
